// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import RoleRoute from './components/RoleRoute';
import Layout from './components/Layout';

// 各画面コンポーネントをインポート
import Mypage from './pages/Mypage';
import Login from './pages/Login';
import Welcome from './pages/Welcome';
import MemberRegistration from './pages/MemberRegistration';
import MemberRegistrationConfirm from './pages/MemberRegistrationConfirm';
import AdminMemberRegistration from './pages/AdminMemberRegistration';

import RouteCheck from './pages/RouteCheck';
import RouteCheckConfirm from './pages/RouteCheckConfirm';
import PhotoPermission from './pages/PhotoPermission';
import ConfidentialityAgreement from './pages/ConfidentialityAgreement';
import FirstComplete from './pages/Complete/FirstComplete';
import MemberList from './pages/MemberList';
import MemberRegistrationConfirmMyPage from './pages/MemberRegistrationConfirmMyPage';
import EditMemberRegistration from './pages/EditMemberRegistration';
import UpdateCompletePage from './pages/UpdateCompletePage';
import RouteConfirmMyPage from './pages/RouteConfirmMyPage';
import EditRouteRegistration from './pages/EditRouteRegistration';
import MemberDetail from './pages/MemberDetail';
import AdminMemberRegistrationDetail from './pages/AdminMemberRegistrationDetail';
import BranchList from './pages/BranchList';
import Consents from './pages/Consents';
import ChangePassword from './pages/ChangePassword';
import Qualifications from './pages/Qualifications';
import DocumentResign from './pages/DocumentResign';
import DocumentList from './pages/DocumentList';
import DocumentEdit from './pages/DocumentEdit';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes with common layout */}
        <Route element={<ProtectedRoute />}> 
          <Route element={<Layout />}> 
            <Route path="/" element={<Mypage />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/member-registration" element={<MemberRegistration />} />
            <Route path="/member-registration-confirm" element={<MemberRegistrationConfirm />} />
            <Route path="/route-check" element={<RouteCheck />} />
            <Route path="/route-check-confirm" element={<RouteCheckConfirm />} />
            <Route path="/photo-permission" element={<PhotoPermission />} />            
            <Route path="/confidentiality-agreement" element={<ConfidentialityAgreement />} />            
            <Route path="/first-complete" element={<FirstComplete />} />      
            <Route path="/member-registration-confirm-mypage" element={<MemberRegistrationConfirmMyPage />} />      
            <Route path="/route-confirm-mypage" element={<RouteConfirmMyPage />} />      
            <Route path="/edit-member-registration" element={<EditMemberRegistration />} />
            <Route path="/edit-route-registration" element={<EditRouteRegistration />} />
            <Route path="/update-complete-Page" element={<UpdateCompletePage />} />
            <Route path="/consents" element={<Consents />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/qualifications" element={<Qualifications />} />
            <Route path="/documents/:key/resign" element={<DocumentResign />} />

            {/* 管理者/人事/支社長 メンバー一覧 */}
            <Route element={<RoleRoute allowedRoles={[1,2,3,4]} />}>
              <Route path="/member-list" element={<MemberList />} />
              <Route path="/member-detail/:id/:type" element={<MemberDetail />} />
            </Route>

            {/* 管理者/人事専用 */}
            <Route element={<RoleRoute allowedRoles={[1,2,3]} />}>
              <Route path="/branch-list" element={<BranchList />} />
              <Route path="/admin/member-registration" element={<AdminMemberRegistration />} />
              <Route path="/admin/existing-member-registration" element={<AdminMemberRegistrationDetail />} />
              <Route path="/admin/documents" element={<DocumentList />} />
              <Route path="/admin/documents/:key" element={<DocumentEdit />} />
            </Route>
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<div style={{padding:24}}>ページが見つかりません</div>} />
      </Routes>
    </Router>
  );
}

export default App;
